module.exports = __webpack_public_path__ + "img/gp_main06.f1d96be3.png";